import React from 'react';
import { Loading } from './Loading';

type RouterLoadingProps = {
    children?: any;
};
export const RouterLoading = ({ children }: RouterLoadingProps) => {
    return children || <Loading global={true} />;
};
